const GET_CORPOTATE_CHART = 'GetChart';
const GET_LOCATION_CHART = 'GetLocationExposureGraph';

export { GET_CORPOTATE_CHART, GET_LOCATION_CHART };
